import { createEffect } from "effector";
import { FraudBlock, Page, UnblockFraudPayload } from "../../types/fraud.types";
import { getFraudBlocks, unblockFraud } from "../../services/fraudService";
import { AppError } from "../../services/classes";

interface GetFraudBlocksParams {
  page?: number;
  size?: number;
  search?: string;
}

export const getFraudBlocksEffect = createEffect<
  GetFraudBlocksParams | void,
  Page<FraudBlock>,
  AppError
>(async (params) => {
  return await getFraudBlocks(params?.page, params?.size, params?.search);
});

export const unblockFraudEffect = createEffect<UnblockFraudPayload, string, AppError>(
  async ({ cpf, notes }: UnblockFraudPayload) => {
    return await unblockFraud(cpf, notes);
  }
);
